<template>
  <div>
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><router-link to="/index">首頁</router-link></li>
            <li><router-link to="/news/list">最新消息</router-link></li>
            <li> {{ title }}</li>
          </ul>
        </div>
      </div>

      <!--開始-->

      <div class="bodyContent">
        <div class="container">

          <div class="notice_inner">
            <div class="hd">
              <h1>
                {{ title }}
              </h1>
              <div class="metainfo">
                <b>{{ title }}</b>
                <span>{{new Date(this.noticeListDatas.starts_at).toLocaleDateString()}}</span>
              </div>
            </div>

            <section class="uploadArea p_mgin20">
              <span v-html="this.noticeListDatas.content"></span>
            </section>
          </div>

        </div>
      </div>

      <!--結束-->

    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'async',
  metaInfo () {
    if (this.title !== '') {
      return {

        title: this.title + ' | 最新消息 | 一刻鯨選',
        meta: [
          // OpenGraph data (Most widely used)
          { property: 'og:title', content: this.title + ' | 最新消息 | 一刻鯨選' },
          { property: 'og:site_name', content: this.title + ' | 最新消息 | 一刻鯨選' },
          // The list of types is available here: http://ogp.me/#types
          { property: 'og:type', content: 'website' },
          // Should the the same as your canonical link, see below.
          { property: 'og:url', content: window.location.toString() },
          { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
          // Often the same as your meta description, but not always.
          { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

        ]
      }
    }
  },

  data () {
    return {
      noticeListDatas: [],
      id: 0,
      title: ''
    }
  },
  created () {
    this.id = window.location.toString()
    var index = this.id.lastIndexOf('/')

    this.id = this.id.substring(index + 1, this.id.length)
    this.axios
      .get(this.$store.getters.baseURL + 'announcements')
      .then(response => {
        let i = 0

        for (i; i < response.data.length; i++) {
          // eslint-disable-next-line eqeqeq
          if (response.data[i].id == this.id) {
            this.noticeListDatas = response.data[i]
            this.title = this.noticeListDatas.title
          }
        }
      })
      .catch(error => console.log('log:' + error))
  },
  mounted () {
    $('body').removeClass('index')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/NoticeInnerpage.vue